import {createSlice} from "@reduxjs/toolkit";
import {extraReducers} from "./action";

const initialState = {
    items: [],
    loadingStatus: 'loaded',
}

const projectSlice = createSlice({
        name: 'projectInfo',
        initialState,
        reducers: {},
        extraReducers: extraReducers()
    }
);

const {actions, reducer} = projectSlice;

export default reducer;

export const {} = actions;
